<umkt-register-token *ngIf="hasToken$ | async"></umkt-register-token>
<umkt-register *ngIf="(hasToken$ | async) === false"></umkt-register>